import * as React from 'react'
import clsx from 'clsx'
import { useGridRootProps } from '../../hooks/utils/useGridRootProps'
import styles from '../../style'

export const GridColumnHeaderRow = React.forwardRef(function GridColumnHeaders(
  props: React.HTMLAttributes<HTMLDivElement>,
  ref: React.Ref<HTMLDivElement>
) {
  const { children, ...other } = props
  const rootProps = useGridRootProps()

  return (
    <div
      ref={ref}
      className={clsx(
        styles.columnHeaderRow,
        rootProps.classes?.columnHeaderRow
      )}
      {...other}
    >
      {children}
    </div>
  )
})
